module.exports = __webpack_public_path__ + "img/NovoBank.2b3033c5.svg";